import { call, take, put } from 'redux-saga/effects';
import { get, post } from '../../utils/api';
import { isEmpty } from 'lodash';
import settings from '../../utils/settings';
import {
  GET_DEALER_LIST_FAILURE,
  GET_DEALER_LIST_SUCCESS,
  GET_DEALER_LIST_REQUEST,
  DEALER_SEARCH_FAILURE,
  DEALER_SEARCH_REQUEST,
  DEALER_SEARCH_SUCCESS,
  ADD_DEALER_SUCCESS,
  ADD_DEALER_REQUEST,
  ADD_DEALER_FAILURE,
  UPDATE_DEALER_STATUS_REQUEST,
  UPDATE_DEALER_STATUS_SUCCESS,
  UPDATE_DEALER_STATUS_FAILURE,
  DEALER_COUNTRY_LIST_SUCCESS,
  DEALER_COUNTRY_LIST_FAILURE,
  DEALER_COUNTRY_LIST_REQUEST
} from './constants';

export function* getDealerListFlow() {
  while (true) {
    const request = yield take(GET_DEALER_LIST_REQUEST);
    try {
      const response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/authorized_dealers/list`),
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: GET_DEALER_LIST_SUCCESS,
            dealerList: response.result
          });
        } else {
          yield put({ type: GET_DEALER_LIST_FAILURE, error: result.message });
        }
      }
    } catch (error) {
      console.log('Saga: getDealerListFlow:', error);
      yield put({ type: GET_DEALER_LIST_FAILURE, error: error });
    }
  }
}

export function* addAuthorizedDealerFlow() {
  while (true) {
    const request = yield take(ADD_DEALER_REQUEST);
    const { company_id, filterData } = request.payload;
    try {
      const response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/authorized_dealers/${company_id}/create`),
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result.data) {
          result.data.company_id = company_id;
          yield put({
            type: ADD_DEALER_SUCCESS,
            dealer: response.result
          });
          yield put({ type: GET_DEALER_LIST_REQUEST, payload: filterData });
        } else {
          yield put({ type: ADD_DEALER_FAILURE, error: result });
        }
      } else {
        yield put({ type: ADD_DEALER_FAILURE, error: response.result });
      }
    } catch (error) {
      console.log('Saga: addAuthorizedDealerFlow:', error);
      yield put({ type: ADD_DEALER_FAILURE, error: error });
    }
  }
}

export function* searchDealerFlow() {
  while (true) {
    const request = yield take(DEALER_SEARCH_REQUEST);
    const { searchVal } = request.payload;
    try {
      const response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/authorized_dealers/search?email=${searchVal.replace(/\+/g,"%2B")}`)
      });
      if (response.success) {
        const { result } = response;
        if (!isEmpty(result.data)) {
          yield put({
            type: DEALER_SEARCH_SUCCESS,
            dealerSearch: result
          });
        } else {
          yield put({ type: DEALER_SEARCH_FAILURE, error: result });
        }
      } else {
        yield put({ type: DEALER_SEARCH_FAILURE, error: response.result });
      }
    } catch (error) {
      console.log('Saga: searchDealerFlow:', error);
      yield put({ type: DEALER_SEARCH_FAILURE, error: error });
    }
  }
}

export function* authorizedDealerStatusUpdateFlow() {
  while (true) {
    const request = yield take(UPDATE_DEALER_STATUS_REQUEST);
    const { authorized_dealer_id, status, name } = request.payload;
    try {
      const response = yield call(post, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/authorized_dealers/status_update`),
        body: { authorized_dealer_id, status }
      });
      if (response.success) {
        const { result } = response;
        if (result.data) {
          yield put({
            type: UPDATE_DEALER_STATUS_SUCCESS,
            status: request.payload,
            message: result.message
          });
        } else {
          yield put({ type: UPDATE_DEALER_STATUS_FAILURE, error: result });
        }
      } else {
        yield put({ type: UPDATE_DEALER_STATUS_FAILURE, error: response.result });
      }
    } catch (error) {
      console.log('Saga: authorizedDealerStatusUpdateFlow:', error);
      yield put({ type: UPDATE_DEALER_STATUS_FAILURE, error: error });
    }
  }
}

export function* getAuthDealerCountryListFlow() {
  while (true) {
    const request = yield take(DEALER_COUNTRY_LIST_REQUEST);
    try {
      const response = yield call(get, {
        url: settings.getApiUrl(`service/enlm_ms/api_internal/authorized_dealers/country_list`)
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: DEALER_COUNTRY_LIST_SUCCESS,
            countryList: result
          });
        } else {
          yield put({ type: DEALER_COUNTRY_LIST_FAILURE, error: result.message });
        }
      }
    } catch (error) {
      console.log('Saga: getAuthDealerCountryListFlow:', error);
      yield put({ type: DEALER_COUNTRY_LIST_FAILURE, error: error });
    }
  }
}
